import create from 'zustand';

interface ICookieStatusState {
  readonly cookieStatus: boolean;
  readonly setCookieStatus: (cookieStatus: boolean) => void;
}

const useCookieStatusStore = create<ICookieStatusState>((set) => ({
  cookieStatus: false,
  setCookieStatus: (cookieStatus: boolean) => set({ cookieStatus }),
}));

export default useCookieStatusStore;
